import { useEffect, useState } from "react";
import { Lock } from "lucide-react";
import { api } from "@/lib/api";
import { useAutosave } from "@/lib/autosave";
import { RichEditor, SaveIndicator } from "@/components/notes/RichEditor";

const Editor = ({ apptId, initial }) => {
  const [html, setHtml] = useState(initial);
  const { status } = useAutosave({ html }, (d) => api.put(`/me/appuntamenti/${apptId}/appunti`, { body_html: d.html }));
  return (
    <>
      <div className="flex justify-end -mt-6 mb-1"><SaveIndicator status={status} testid="appt-note-save-status" /></div>
      <RichEditor value={html} onChange={setHtml} minHeight={160} placeholder="Appunti privati su questo appuntamento..." testid="appt-note" />
    </>
  );
};

export const ApptPrivateNote = ({ apptId }) => {
  const [initial, setInitial] = useState(null);
  useEffect(() => { setInitial(null); api.get(`/me/appuntamenti/${apptId}/appunti`).then((r) => setInitial(r.data.body_html || "")); }, [apptId]);
  return (
    <section className="mt-2" data-testid="appt-private-note">
      <h4 className="text-xs font-bold uppercase tracking-wider text-[#0A1128] flex items-center gap-1.5 mb-2"><Lock className="h-3.5 w-3.5 text-[#E8173A]" />I miei appunti (visibili solo a te)</h4>
      {initial === null ? <div className="text-sm text-slate-600">Caricamento...</div> : <Editor key={apptId} apptId={apptId} initial={initial} />}
    </section>
  );
};
